import { TrackingService } from '@/services/analytics/TrackingService';
import type { RoutePoint } from '@/types/route-simulation';
import type { TRANSPORTATION_REQUEST_TYPE } from 'dabeeomaps';

export type NavigationTrackingParams = {
    startBuildingId: string;
    startFloorId: string;
    startPosition: { x: number; y: number };
    endBuildingId: string;
    endFloorId: string;
    endPoiId: string;
    endPosition: { x: number; y: number };
    menuId?: string;
    transportMode?: TRANSPORTATION_REQUEST_TYPE;
};

export const trackFloorGuideNavigation = (params: NavigationTrackingParams) => {
    TrackingService.trackNavigation(params);
};

export const buildNavigationParams = (opts: {
    startBuildingId: string;
    startPoint: RoutePoint;
    endBuildingId: string;
    endPoint: RoutePoint;
    endPoiId: string;
    transportMode?: TRANSPORTATION_REQUEST_TYPE;
}): NavigationTrackingParams => ({
    startBuildingId: opts.startBuildingId,
    startFloorId: opts.startPoint.floorId,
    startPosition: { x: opts.startPoint.position?.x ?? 0, y: opts.startPoint.position?.y ?? 0 },
    endBuildingId: opts.endBuildingId,
    endFloorId: opts.endPoint.floorId,
    endPoiId: opts.endPoiId,
    endPosition: { x: opts.endPoint.position?.x ?? 0, y: opts.endPoint.position?.y ?? 0 },
    ...(opts.transportMode ? { transportMode: opts.transportMode } : {}),
});
